// Returns 'expired' | 'expiring' (<=30 days left) | 'active' for a license end_date
export const getLicenseExpiryStatus = (endDate) => {
  const days = Math.floor((new Date(endDate) - new Date()) / (1000 * 60 * 60 * 24));
  if (days < 0) return 'expired';
  if (days <= 30) return 'expiring';
  return 'active';
};

// Returns true if an item's registered_at timestamp is within the last N days (default 7) — used for a "new" badge
export const isRecentlyRegistered = (registeredAt, withinDays = 7) => {
  if (!registeredAt) return false;
  const days = Math.floor((new Date() - new Date(registeredAt)) / (1000 * 60 * 60 * 24));
  return days >= 0 && days <= withinDays;
};

// Buckets items by their registered_at date into `periods` equal-width windows spanning the last `days` days,
// returning a cumulative running-total array suitable for a sparkline (real data derived from registration timestamps).
export const getRegistrationTrend = (items, days = 30, periods = 12) => {
  const now = new Date();
  const startTime = now.getTime() - days * 24 * 60 * 60 * 1000;
  const bucketMs = (days * 24 * 60 * 60 * 1000) / periods;

  const baseline = items.filter(item => {
    const t = new Date(item.registered_at || 0).getTime();
    return t && t < startTime;
  }).length;

  const buckets = new Array(periods).fill(0);
  items.forEach(item => {
    const t = new Date(item.registered_at || 0).getTime();
    if (!t || t < startTime) return;
    const idx = Math.min(periods - 1, Math.floor((t - startTime) / bucketMs));
    buckets[idx] += 1;
  });

  let running = baseline;
  return buckets.map(count => (running += count));
};

export const searchOptions = {
  systems: [
    { value: "uuid", label: "System UID" },
    { value: "project_id", label: "Project ID" },
    { value: "software_id", label: "Software ID" },
  ],
  licenses: [
    { value: "license_id", label: "License ID" },
    { value: "uuid", label: "System UID" },
    { value: "project_id", label: "Project ID" },
    { value: "software_id", label: "Software ID" },
  ],
  cameras: [
    { value: "uuid", label: "System UID" },
    { value: "camera_serial", label: "Camera Serial" },
    { value: "project_id", label: "Project ID" },
  ],
};
